class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.focusTimer = null;
    this.viewCartButton = this.querySelector('[data-cart-notification-view-cart]');
    
    this.notification.setAttribute('aria-hidden', 'true');
    this.setNotificationMessage('cart');
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('[data-cart-notification-close]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.viewCartButton?.addEventListener('click', () => {
      window.location.href = this.viewCartButton.dataset.cartUrl || '/cart';
    });
  }

  open() {
    window.clearTimeout(this.focusTimer);
    removeTrapFocus();

    this.notification.setAttribute('aria-hidden', 'false');
    this.notification.classList.add('animate', 'active');

    const focusNotification = () => {
      trapFocus(this.notification, this.querySelector('[data-cart-notification-close]') || this.notification);
    };

    window.requestAnimationFrame(() => {
      this.focusTimer = window.setTimeout(focusNotification, 0);
    });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    window.clearTimeout(this.focusTimer);
    this.notification.setAttribute('aria-hidden', 'true');
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.setNotificationMessage('item-added');
      this.getSectionsToRender().forEach((section => {
        const sectionElement = document.getElementById(section.id);
        const sectionHTML = parsedState.sections[section.id];

        if (!sectionElement || !sectionHTML) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  renderCartContents(parsedState) {
      this.setNotificationMessage('cart');
      this.getSectionsToRender().forEach((section => {
        const sectionElement = document.getElementById(section.id);
        const sectionHTML = parsedState.sections[section.id];

        if (!sectionElement || !sectionHTML) return;

        sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML, section.cartSelector || section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  setNotificationMessage(type) {
      const isItemAdded = type === 'item-added';
      const label = isItemAdded ? this.notification.dataset.itemAddedLabel : this.notification.dataset.cartLabel;
      const headingText = this.querySelector('[data-cart-notification-heading]');
      const headingIcon = this.querySelector('[data-cart-notification-heading-icon]');

      if (label) {
        this.notification.setAttribute('aria-label', label);
        if (headingText) headingText.textContent = label;
      }

      if (headingIcon) headingIcon.toggleAttribute('hidden', !isItemAdded);
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
        cartSelector: '.shopify-section',
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    return (parsedHTML.querySelector(selector) || parsedHTML.body).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
